import { NgTemplateOutlet } from '@angular/common';
import { Component, Input } from '@angular/core';

import moment from 'moment-timezone';

import { I18nService } from '@core/i18n-legacy';
import type { JobSchedulerData } from '@core/offers-types';
import type { IconToken } from '@core/user-interface-legacy';
import {
  RtTooltip,
  ButtonComponent,
  GroupComponent,
  IconButtonComponent,
  IconComponent,
} from '@core/user-interface-legacy';

@Component({
  selector: 'rt-job-scheduler-button',
  templateUrl: './job-scheduler-button.component.html',
  styleUrls: ['./job-scheduler-button.component.less'],
  imports: [
    ButtonComponent,
    RtTooltip,
    IconComponent,
    NgTemplateOutlet,
    IconButtonComponent,
    GroupComponent,
  ],
})
export class JobSchedulerButtonComponent {
  private readonly SDAY_FORMAT = 'DD MMM YYYY';

  public readonly translations = {
    availableInScale: this.i18n.translate('app.pricing.feature_guard.available_in_scale'),
    closeScheduled: this.i18n.translate('app.job_scheduler.schedule_button.close_scheduled'),
    editCloseDate: this.i18n.translate('app.job_scheduler.schedule_button.edit_close_date'),
    editPublishDates: this.i18n.translate('app.job_scheduler.schedule_button.edit_publish_dates'),
    editPublishDate: this.i18n.translate('app.job_scheduler.schedule_button.edit_publish_date'),
    jobScheduled: this.i18n.translate('app.job_scheduler.schedule_button.job_scheduled'),
    publishScheduled: this.i18n.translate('app.job_scheduler.schedule_button.publish_scheduled'),
    schedulePublishDates: this.i18n.translate(
      'app.job_scheduler.schedule_button.schedule_publish_dates',
    ),
  };

  @Input() public schedulerData?: JobSchedulerData;
  @Input() public active: boolean = false;
  @Input() public featureAvailable: boolean = false;
  @Input() public discriminationIconColor?: IconToken;
  @Input() public discriminationTooltip?: string;

  public get isPublishDate(): boolean {
    return !!this.schedulerData?.publishDate;
  }
  public get isCloseDate(): boolean {
    return !!this.schedulerData?.closeDate;
  }
  public get bothDates(): boolean {
    return !!(this.schedulerData?.publishDate && this.schedulerData?.closeDate);
  }

  constructor(private i18n: I18nService) {}

  public getFormattedDay(eventDate?: string): string {
    return moment(eventDate).format(this.SDAY_FORMAT);
  }
}
